<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="费用类型" prop="feeName">
            <dict-select
              clearable
              filterable
              v-model="formData.feeName"
              placeholder="请选择费用类型"
              default
              :body="feeNameDictParams"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否关联线路" prop="isLineFee">
            <el-radio-group v-model="formData.isLineFee">
              <el-radio label="N">和线路无关</el-radio>
              <el-radio label="Y">关联线路</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formData.isLineFee === 'Y'">
          <el-form-item label="线路选择" prop="contractLineCode">
            <line-select
              @change="lineChange"
              :contractLineCode="formData.contractLineCode"
              :contractCode="contractCode"
              style="width:100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="计费方式" prop="priceType">
            <dict-select
              filterable
              clearable
              v-model="formData.priceType"
              placeholder="请选择计费方式"
              default
              :body="billingPlanDictParams"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="['B', 'C', 'E'].includes(formData.priceType)">
          <el-form-item label="计费单位" prop="chargeUnit">
            <dict-select
              filterable
              clearable
              v-model="formData.chargeUnit"
              placeholder="请选择计费单位"
              default
              :body="chargeUnitDictParams"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="formData.priceType !== 'A'">
          <el-form-item
            label="计算公式"
            prop="chargeFormula"
            v-if="formData.priceType === 'D'"
          >
            <dict-select
              filterable
              clearable
              v-model="formData.chargeFormula"
              placeholder="请选择计算公式"
              default
              :body="chargeFormulaDictParams"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="比例"
            v-if="formData.priceType == 'D'"
            prop="basePrice"
            ref="basePriceForm"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.basePrice"
              :step="0.01"
              :precision="2"
              :min="0"
              controls-position="right"
              placeholder="请输入比例"
              size="small"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="首价"
            v-if="formData.priceType !== 'D'"
            prop="basePrice"
            ref="basePriceForm"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.basePrice"
              :step="0.01"
              :precision="2"
              :min="0"
              controls-position="right"
              placeholder="请输入首价"
              size="small"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="feeRemark">
            <el-input
              v-model="formData.feeRemark"
              type="textarea"
              placeholder="请输入备注"
              :rows="2"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="formData.priceType !== 'A'">
      <fee-tiered-table
        v-if="feeTieredDisplay"
        ref="table"
        :tableData="formData.feeTieredList"
        :basePrice="formData.basePrice"
        :priceTypeString="priceTypeString"
      />
    </div>
  </div>
</template>
<script>
import FeeTieredTable from '../fee-tiered-table'
import LineSelect from '../line-select'
import validate from '@/libs/util.validate'
export default {
  components: {
    FeeTieredTable,
    LineSelect,
  },
  props: {
    contractCode: String,
    contractFeeCode: String,
  },
  data() {
    return {
      chargeUnitDictParams: { type: 'chargeUnit' },
      feeNameDictParams: { type: 'feeName' },
      chargeFormulaDictParams: { type: 'chargeFormula' },
      billingPlanDictParams: { type: 'billingPlan' },
      feeTieredDisplay: true,
      priceTypeString: '',
      formData: {
        isLineFee: 'N',
        contractCode: this.contractCode,
        feeTieredList: [],
        priceType: null,
        contractLineCode: '',
        chargeUnit: '',
      },
      rules: {
        feeName: [
          {
            required: true,
            message: '请选择费用类型',
            trigger: 'change',
          },
        ],
        contractLineCode: [
          {
            required: true,
            message: '请选择线路信息',
            trigger: 'change',
          },
        ],
        priceType: [
          {
            required: true,
            message: '请选择计费方式',
            trigger: 'change',
          },
        ],
        chargeUnit: [
          {
            required: true,
            message: '请选择计费单位',
            trigger: 'change',
          },
        ],
        basePrice: [
          {
            required: false,
            message: '请输入首价',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    contractFeeCode: {
      handler(contractFeeCode) {
        if (contractFeeCode || contractFeeCode !== '') {
          this.loadDetail()
        }
      },
      immediate: true,
    },
    'formData.priceType'(newVal) {
      if (newVal) {
        if (newVal === 'A') {
          this.formData.chargeUnit = ''
          this.rules.basePrice[0].required = true
        } else {
          this.rules.basePrice[0].required = false
          this.$refs.basePriceForm.clearValidate()
        }
      } else {
        this.rules.basePrice[0].required = false
      }
      const priceType = this.formData.priceType
      if (priceType === 'D') {
        this.feeTieredDisplay = false
      } else {
        this.feeTieredDisplay = true
      }
      if (priceType === 'B' || priceType === 'C'){
        this.priceTypeString = "单价"
      }else if (priceType === "E"){
        this.priceTypeString = "运价"
      }
    },
  },
  methods: {
    loadDetail() {
      this.$api
        .contractCustomerFeeDetailApi({
          contractFeeCode: this.contractFeeCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    lineChange(val) {
      this.formData.contractLineCode = val
    },
    // onChargeFormulaChange(val) {
    //   if (val) {
    //     this.feeTieredDisplay = true
    //   }
    // },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return Promise.reject()

      if (this.formData.isLineFee === 'N') this.formData.contractLineCode = ''

      if (this.formData.priceType !== 'A' && this.feeTieredDisplay) {
        const tableData = await this.$refs.table.getTableData()
        if (!tableData || !tableData.length) {
          this.$message.warning('请添加阶梯价格信息')
          return Promise.reject()
        }

        const validResult = await this.$refs.table.validEvent()
        if (!validResult) return Promise.reject()

        this.formData.feeTieredList = tableData
      }

      if (!this.formData.basePrice) this.formData.basePrice = 0
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      return this.$api
        .contractCustomerFeeSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          const { status, msg } = res
          this.$message({
            type: status === 200 ? 'success' : 'error',
            message: msg,
          })
          return res
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  },
}
</script>
